import { createContext, useState, useEffect, useContext, useMemo, useRef } from "react";
import { io } from "socket.io-client";
import { AuthContext } from "./authContext";
import { useChatDatabase } from "../lib/chatDatabase";

export const SocketContext = createContext();

export const SocketContextProvider = ({ children }) => {
    const [socket, setSocket] = useState(null);
    const [onlineUsers, setOnlineUsers] = useState([]);
    const { currentUser, logout, privateKey } = useContext(AuthContext);

    const privateKeyRef = useRef(privateKey);

    useEffect(() => {
        privateKeyRef.current = privateKey;
    }, [privateKey]);
  
    useEffect(() => {
        if (currentUser?.id) {
            const socketUrl = process.env.REACT_APP_SOCKET_URL || "http://localhost:8900"; 

            const newSocket = io(socketUrl, {
                withCredentials: true
            });

            setSocket(newSocket);
            newSocket.emit("addUser", currentUser.id);

            newSocket.on("getUsers", (users) => {
                setOnlineUsers(users);
            });

            newSocket.on("force_logout", async (data) => {
                alert(data?.message || "Your account has been forcibly logged out!");
                await logout(); 
                window.location.href = "/login";
            });

            newSocket.on("getMessage", (incomingMessage) => {
                // useChatDatabase.getState().addIncomingMessage(incomingMessage, privateKey);
                useChatDatabase.getState().addIncomingMessage(incomingMessage, privateKeyRef.current);
            });

            return () => {
                newSocket.off("getUsers");
                newSocket.off("force_logout");
                newSocket.off("getMessage");
                newSocket.disconnect();
                setSocket(null);
                setOnlineUsers([]);
            };
        }
    }, [currentUser?.id, logout]); 

    const contextValue = useMemo(
        () => ({ socket, onlineUsers }),
        [socket, onlineUsers]
    );

    return (
        <SocketContext.Provider value={contextValue}>
            {children}
        </SocketContext.Provider>
    );
};